export default class {
  setDateTimeRangeWidth () {
    let box = this.$refs.box.$el
    let input = $(box.querySelector('.el-input'))
    let item = $(box.querySelector('.el-form-item'))
    let width = $(box.querySelector('.el-range-input')).width() * 2 + parseInt(this.labelWidth || 0) + parseInt(item.css('margin-right')) + 4 - 20
    // let width = $(box).width()
    // $(box.querySelectorAll('.el-form-item__content')).width(width / 3).each(function() {
    //   $(this).children().eq(0).width('calc(100% - 20px)')
    // })
    $(box.querySelectorAll('.el-date-editor--datetimerange')).width(width)
    $(box.querySelectorAll('.el-date-editor--daterange')).width(width)
    $(box.querySelectorAll('.t-filter-item-2')).width(input.width() * 2 + parseInt(this.labelWidth || 0) + parseInt(item.css('margin-right')) + 4)
  }
  clickSubmit () {
    this.$emit('clickSubmit')
  }
  clickReset () {
    this.$emit('clickReset')
  }
  clickExport(){
    this.$emit('clickExport')
  }
  /**
   * 下载文件
   */
  handleDownloadClick (row) {
    this.$emit('handleDownloadClick')
    // let a = document.createElement('a') // 创建a标签
    // let e = document.createEvent('MouseEvents') // 创建鼠标事件对象
    // e.initEvent('click', false, false) // 初始化事件对象
    // a.target = '_blank'
    // a.href = '/static/档案.pdf' // 设置下载地址
    // a.download = '档案' // 设置下载文件名
    // a.dispatchEvent(e) // 给指定的元素，执行事件click事件
  }
  downloadFileClick(){
    this.$emit('downloadFileClick')
  }
  downloadFileAndPicClick(){
    this.$emit('downloadFileAndPicClick')
  }
}
